import { render, staticRenderFns } from "./ProductInfoImage.vue?vue&type=template&id=da49cab4&scoped=true&lang=pug&"
import script from "./ProductInfoImage.vue?vue&type=script&lang=js&"
export * from "./ProductInfoImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoImage.vue?vue&type=style&index=0&id=da49cab4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da49cab4",
  null
  
)

export default component.exports